import { render } from "./PaymentScreen.vue?vue&type=template&id=cadaaae4&scoped=true&ts=true"
import script from "./PaymentScreen.vue?vue&type=script&lang=ts"
export * from "./PaymentScreen.vue?vue&type=script&lang=ts"

import "./PaymentScreen.vue?vue&type=style&index=0&id=cadaaae4&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cadaaae4"]])

export default __exports__